import EditPage from "../../components/EditPage";
import QuillEditor from "../../util/QuillEditor.js"
import { useParams } from "react-router-dom";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";
import TextInput from "../../components/TextInput";
import ImageSelector from "../../components/ImageSelector";
import styles from "../../components/PageEdit.module.css"
import {  useRef } from "react";
import EditAuthor from "../../util/edit-author.js";

const uploadFolderId = '18drTAcEWj_si98FoL81bfLcEEDWELE4l';

function Blog({sectionKey, title, content, blog_image, updateField}){
    const quillRef = useRef(null);
        
    return(
        <div className={styles.pageInfoEdit}>
            <h2>{title || "Title"}</h2>
            <TextInput
                label={"Title:"}
                value={title || ""}
                onChange={(e) => updateField(sectionKey, "title", e.target.value)}
            />
            <QuillEditor
                ref={quillRef}
                theme="snow"
                value={content || ""}
                onChange={(value) => updateField(sectionKey, "content", value)}
                placeholder="Write your content here..."
            />
            <ImageSelector 
                value={blog_image || ""}
                updateField={(val) => updateField(sectionKey, "blog_image", val)}
            />
        </div>
    );
}

function AuthorDisplay({sectionKey, author_id, updateField}) {
    // Wrapper of EditAuthor to handle sectionKey correctly
    return (
        <EditAuthor
        author_id={author_id}
        onAuthorChange={(newId) => updateField(sectionKey, "author_id", newId)}
        />
    );
    
}

export default function EditBlog() {

    const { blogId: rawBlogId } = useParams();
    const blog_id = Number(rawBlogId);

    return(
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath={`blog/page/${blog_id}`}>
                <Blog sectionKey="blog"/>
                <AuthorDisplay sectionKey="blog"/>
            </EditPage>
        </UploadFolderIdProvider>
    )
}